module.exports = new __parcel__URL__("tomato.e755033f.svg").toString();